export const headerData = {
    title: 'Mes validations',
    submodules: [
        createData(0, "Validations réelles", "/me/validations"),
        createData(0, "Acceptation demande d'appui", "/acceptedHelp"),
        createData(1, "Validations plannings", "/planning/table"),
        createData(1, "Mes valudateurs", "/myValidators"),
    ],
}

function createData(id, moduleName, ref) {
    return { id, moduleName, ref };
}